/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Tea_Grade_Delete_Blocked_ScentingInputs */

const vi_tea_grade_delete_blocked_scenting = /** @type {(inputs: Tea_Grade_Delete_Blocked_ScentingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lô lấy hương`)
};

/**

* @param {Tea_Grade_Delete_Blocked_ScentingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_delete_blocked_scenting = /** @type {((inputs: Tea_Grade_Delete_Blocked_ScentingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_Delete_Blocked_ScentingInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_delete_blocked_scenting(inputs)
});